import { render, staticRenderFns } from "./AboutMe.vue?vue&type=template&id=1f03dde3&scoped=true"
import script from "./AboutMe.vue?vue&type=script&lang=js"
export * from "./AboutMe.vue?vue&type=script&lang=js"
import style0 from "./AboutMe.vue?vue&type=style&index=0&id=1f03dde3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f03dde3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f03dde3')) {
      api.createRecord('1f03dde3', component.options)
    } else {
      api.reload('1f03dde3', component.options)
    }
    module.hot.accept("./AboutMe.vue?vue&type=template&id=1f03dde3&scoped=true", function () {
      api.rerender('1f03dde3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Informational/AboutMe.vue"
export default component.exports